import React, { useRef, useEffect } from 'react';
import { Navbar } from '../navbar/NavBar';
import { LeftPanel, RightPanel, BottomPanel, ElementInfoPanel, Toolbar } from '../panels';
import { CanvasStage, Selection, SelectionOverLayer, DragSnap, CanvasToolsHandler } from './stage';
import { UndoRedo } from './base';
import { ContextMenu } from '../menu';
import { Elements, Overlayers } from './elements';
import { FlowWrapper } from '../flow';
import { setProjectState, useProjectState } from '../../store';
import debounce from 'lodash/debounce';
export const canvasContainerId = 'canvas-container';

export const Canvas = () => {
  const canvasContainerRef = useRef(null);
  const canvasSize = useProjectState('canvasSize');

  useEffect(() => {
    const resizeObserver = new ResizeObserver(
      debounce((entries) => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setProjectState({ canvasSize: [width, height] });
        }
      }),
    );

    resizeObserver.observe(canvasContainerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div className="relative flex flex-col items-stretch w-screen h-screen overflow-hidden">
      <Navbar />
      <div className="flex items-stretch" id={canvasContainerId}>
        <div className="relative flex-1 overflow-hidden" ref={canvasContainerRef}>
          {!!canvasSize[0] && (
            <CanvasStage width={canvasSize[0]} height={canvasSize[1]}>
              <DragSnap />
              <Elements />
              <Selection />
              <CanvasToolsHandler />
            </CanvasStage>
          )}
          <Overlayers />
          <BottomPanel />
          <SelectionOverLayer />
        </div>
        <Toolbar />
        <LeftPanel />
        <RightPanel />
      </div>
      <FlowWrapper />
      <ContextMenu />
      <ElementInfoPanel />
      <UndoRedo />
    </div>
  );
};
